import * as yup from 'yup'

export const authenticateSchema = yup.object({
	email: yup.string().email('E-mail inválido').required('Campo obrigatório'),
	password: yup
		.string()
		.required('Campo obrigatório')
		.min(6, 'A senha deve ter pelo menos 6 caracteres'),
})

export const recoveryEmailSchema = yup.object({
	email: yup.string().email('E-mail inválido').required('Campo obrigatório'),
})

export const resetPassWordSchema = yup.object({
	password: yup
		.string()
		.required('Campo obrigatório')
		.min(6, 'A senha deve conter pelo menos 8 caracteres'),
	retypePassword: yup
		.string()
		.required('Campo obrigatório')
		.oneOf(
			[yup.ref('password')],
			'Ops! Suas senhas devem ser iguais, tente novamente.'
		),
})

export const signUpSchema = yup.object({
	name: yup.string().required('Campo obrigatório'),
	email: yup.string().email('E-mail inválido').required('Campo obrigatório'),
	password: yup
		.string()
		.required('Campo obrigatório')
		.min(6, 'A senha deve ter pelo menos 6 caracteres'),
	interest: yup.string().required('Campo obrigatório'),
	phone: yup.string().required('Campo obrigatório'),
})
